/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EventType {
	INFO = "Info",
	ERROR = "Error",
	WARN = "Warn",
	USER_ERROR = "UserError",
	SYSTEM_ERROR = "SystemError",
}
